import classNames from 'classnames';

const Icon = ({className, type, children, ...props}) => (
    <i {...props} className={classNames('material-icons', className)}>
        {type || children}
    </i>
);

export default Icon;
